export const cardInventoryControl = {
	cardInfo: {
		stockist: "Stockist:",
		editedIn: "Edited on:",
		status: "Status:",
		statusTag: {
			approved: "Approved",
			open: "Open",
			in_review: "In review",
			reopened: "Reopened",
		},
	},
};
